// extracted by mini-css-extract-plugin
export var wrapper = "x_b";
export var slider = "x_b5";
export var sliderThumb = "x_b6";
export var legend = "x_b7";